module.exports = __webpack_public_path__ + "static/media/godownVector.ab966413.svg";